import React, { Component } from 'react';
import './Spinner.css';

class Spinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="spinnerWrapper">
      <div className="spinner">
        
        </div>
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js